import { createLogger } from 'ia-react-core';

const logger = createLogger();

export default logger;
